module.exports = __webpack_public_path__ + "img/monitor-icon.3008cdfc.svg";